import {
  StyleProp,
  StyleSheet,
  View,
  ViewStyle,
} from "react-native";
import { colors } from "../common/styles/colors";

export function Indicator({
  style,
  isActive,
}: {
  style?: StyleProp<ViewStyle>;
  isActive: boolean;
}) {
  return (
    <View
      style={[
        styles.indicator,
        style,
        isActive && { backgroundColor: colors.noteGray },
      ]}
    />
  );
}

const styles = StyleSheet.create({
  indicator: {
    width: 4,
    height: 4,
    borderRadius: 2,
    backgroundColor: colors.gray81,
    marginLeft: 4,
  },
});
